import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import {
    GetPrivateMembersGroups,
    CreatePrivateMemberGroup,
    PrivateMemberGroupActionTypes,
    AddPrivateMemberToGroup,
    GetPrivateMemberGroupDetails,
    UpdatePrivateMemberGroup,
    ClearDataForCreateGroup,
    ClearDataForUserAddInPrivateGroup
} from '../store/private-member.action';
import { API } from 'src/app/services/Api.service';
import { CommonService } from 'src/app/services/tasks.services';


@Component({
    selector: 'app-add-member-group',
    templateUrl: './add-member-group.component.html',
    styleUrls: ['./add-member-group.component.scss']
})
export class AddMemberGroupComponent implements OnInit, OnDestroy {

    users = ['Apple', 'Lemon', 'Lime', 'Orange', 'Strawberry'];
    addGroupForm: FormGroup;
    selectedUsers: any =[];
    action: string;
    private stopper$: Subject<any> = new Subject();
    addPrivateGroupClicked: boolean =false;
    showError: boolean =false;
    createGroupClicked: boolean =false;


    constructor(
        private _store: Store<AppState>,
        public dialogRef: MatDialogRef<AddMemberGroupComponent>,
        public action$: Actions,
        private fb: FormBuilder,
        private api: API,
        private notificationService: NotificationsService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private commonService: CommonService
    ) {
        this.dialogRef.disableClose = true;
        this.addGroupForm = this.fb.group({
            name: ['', [Validators.required, Validators.maxLength(60), Validators.pattern('(.*)([a-zA-Z0-9])(.*)$')]],
            description: ['', [Validators.maxLength(200)]],
        });
    }

    ngOnInit() {

        this._store.select(state => state.privateMember.createdGroup).pipe(takeUntil(this.stopper$)).subscribe((response) => {
            if((Object.keys(response). length) && (this.createGroupClicked)) {
                this.dialogRef.close({type: 'createGroup'});
            }
        });


        // this.action$.pipe(
        //   ofType(PrivateMemberGroupActionTypes.CREATE_PRIVATE_MEMBER_GROUP),
        //   switchMap((action: CreatePrivateMemberGroup) => {
        //     return this.api.createPrivateMemberGroup(action.payload).pipe(
        //       map((response: any) => {
        //         const users = this.selectedUsers.map(user => user._id);
        //         this.notificationService.success('Private Members Group created successfully.');
        //         return this._store.dispatch(new AddPrivateMemberToGroup(response._id, users));
        //       }),
        //       catchError(err => of({ type: '' }))
        //     );
        //   })
        // ).subscribe();


        // this.action$.pipe(
        //   ofType(PrivateMemberGroupActionTypes.ADD_PRIVATE_MEMBER_TO_GROUP),
        //   switchMap((action: AddPrivateMemberToGroup) => {
        //     return this.api.addUserToGroup(action.groupId, action.payload).pipe(
        //       map((response: any) => {
        //         this._store.dispatch(new GetPrivateMembersGroups());
        //         if(this.action === 'addMember') {
        //           this._store.dispatch(new GetPrivateMemberGroupDetails(action.groupId));
        //         }
        //         this.dialogRef.close('Private Member Group added successfully.');
        //       }),
        //       catchError(err => of({ type: '' }))
        //     );
        //   })
        // ).subscribe();

        // this.action$.pipe(
        //   ofType(PrivateMemberGroupActionTypes.UPDATE_PRIVATE_MEMBER_GROUP),
        //   switchMap((action: UpdatePrivateMemberGroup) => {
        //     return this.api.updateGroup(action.groupId, action.payload).pipe(
        //       map((response: any) => {
        //         this._store.dispatch(new GetPrivateMemberGroupDetails(action.groupId));
        //         this.dialogRef.close('Private Group Member updated successfully.');
        //       }),
        //       catchError(err => of({ type: '' }))
        //     );
        //   })
        // ).subscribe();

        // this._store.select(state => state.privateMember.userAddedToGroup).pipe(takeUntil(this.userAddStopper$)).subscribe(resp => {
        //     if (resp && Object.keys(resp).length) {
        //         if (this.data && this.data.groupId) {
        //             this.notificationService.success('User added to group Successfully');
        //             this._store.dispatch(new GetPrivateMemberGroupDetails(this.data.groupId));
        //             this.dialogRef.close('')
        //         }
        //     }
        // })


        if (this.data) {
            this.action = this.data.action;
            if (this.data.action === "editGroup") {
                this.addGroupForm.patchValue({
                    name: this.data.name,
                    description: this.data.description
                });
            }
        }

        this._store.select(state => state.privateMember.userAddedToPrivateGroup).pipe(takeUntil(this.stopper$)).subscribe(resp => {
            if (resp && Object.keys(resp).length) {
              if (this.data && this.data.groupId) {
                this.notificationService.success('User added successfully');
                this._store.dispatch(new GetPrivateMemberGroupDetails(resp._id))
                this.dialogRef.close('')
              }
            }
          })

    }

    getMembers(event) {
        this.selectedUsers = event.selectedItems;
        this.showError =(!this.selectedUsers.length) ? true : false
    }

    updateGroup() {
        const payload = this.addGroupForm.value;
        this._store.dispatch(new AddPrivateMemberToGroup(this.data.groupId, payload));
    }

    addGroup() {
        this.createGroupClicked =true;
        this.showError = (this.selectedUsers.length) ? false: true
        if(!this.showError) {

            this.addPrivateGroupClicked =true;
            let selectedUserIds = [];
            if (this.selectedUsers) {
                selectedUserIds = this.selectedUsers.map(selectedUser => {
                    return selectedUser._id;
                });
            }
            if (!this.addGroupForm.valid) {
                return ;
            }
            const payload = { ...this.addGroupForm.value, 'members': selectedUserIds };
            this._store.dispatch(new CreatePrivateMemberGroup(payload));
        }
       

    }

    addMember() {
        this.showError =!this.selectedUsers.map(({_id})  => _id).length;
        if(!this.showError){
            let payload = {
                members: this.selectedUsers.map(user => user._id)
            }
            this._store.dispatch(new AddPrivateMemberToGroup(this.data.groupId, payload));
            // this.dialogRef.close()
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnDestroy() {
        this.stopper$.next('');
        this._store.dispatch(new ClearDataForCreateGroup())
        this._store.dispatch (new ClearDataForUserAddInPrivateGroup())
    }


}
